



























































































import { Vue, Component, Prop, Provide } from "vue-property-decorator";
import EditPage from "@/components/EditPage";
import { getKennungValueDisplay } from "@/DataHelper";

@Component
export default class ReiseStatus extends EditPage {
  constructor() {
    super();
    this.query = "Web_Reise_Status_Anzeige";
  }
  @Prop({ default: null })
  @Prop({ default: false })
  public showInfo: boolean = false;
  @Prop() public zeitbereichUebergabe!: APIZeitbereich | null;
  public created() {
    this.zeitbereich = this.zeitbereichUebergabe;
  }
  public mounted() {
    this.mountedBase();
  }
}
